<template>
  <div>
    <slot :coupon-errors="couponErrors" :apply-coupon="apply">
      <div class="border border-b-4 rounded">
        <div class="flex items-center justify-between px-6 py-4 coupon">
          <div class="flex flex-col">
            <p class="font-bold leading-none font-display text-warning-500">
              {{ discountValue }}{{ discountSymbol }} {{ $t("off") }}
            </p>
            <p
              class="mt-1 text-sm leading-none tracking-widest text-gray-500 uppercase break-word font-display"
            >
              {{ code }}
            </p>
          </div>

          <VyButton
            :theme="isApplicable ? 'solid' : 'muted'"
            :color="isApplicable ? 'primary' : 'gray'"
            shape="rounded"
            size="sm"
            :label="$t('apply')"
            :disabled="!isApplicable"
            @click="apply(code)"
          />
        </div>

        <!-- Desc -->
        <div v-if="desc" class="border-t-2 border-dashed">
          <button
            class="flex items-center justify-between w-full px-4 py-1"
            @click="(open = !open)"
          >
            <p class="text-xs text-gray-500">{{ $t("details") }}</p>
            <p class="w-6 h-6 text-gray-400">
              <Icon :name="open ? 'MdiChevronDown' : 'MdiChevronRight'" />
            </p>
          </button>
          <div
            v-if="open"
            class="px-4 pb-4 text-xs text-gray-500 whitespace-pre-line"
          >
            <p>{{ desc }}</p>
          </div>
        </div>
      </div>
      <!-- TODO WHY SHOW ERROR below every coupon -->
      <!-- <Error
        class="px-4 py-2 mt-1 text-xs border rounded-md text-danger-600 pe-6 bg-danger-50 border-danger-200"
        :errors="couponErrors"
      /> -->
    </slot>
  </div>
</template>

<script>
import { mapState, mapActions } from "pinia";
import { useVepaarStore } from "@/store/store.js";
import { useCartStore } from "@/store/cart.js";

export default {
  props: {
    id: { type: Number, default: null },
    code: { type: String, default: null },
    discountType: { type: String, default: null },
    discountValue: { type: Number, default: null },
    desc: { type: String, default: null },
    isApplicable: { type: Boolean, default: false },
  },
  data() {
    return {
      open: false,
    };
  },
  computed: {
    ...mapState(useVepaarStore, ["currencySymbol"]),
    ...mapState(useCartStore, ["couponErrors"]),

    discountSymbol() {
      return this.discountType === "percentage" ? "%" : this.currencySymbol;
    },
  },
  methods: {
    ...mapActions(useCartStore, ["upsertCart"]),

    apply(code) {
      if (code) {
        this.upsertCart({ couponCode: code }).then(() => {
          if (!this.couponErrors.length) {
            this.$nuxt.callHook("modal-close", "modal-coupons");
          }
        });
      } else {
        alert("Please enter coupon code!");
      }
    },
  },
};
</script>

<style>
.coupon {
  @apply relative;

  &:before,
  &:after {
    content: "";
    @apply absolute top-0 bottom-0 my-auto rounded-full border bg-white transform dark:bg-gray-850;
    width: 20px;
    height: 20px;
  }

  &:before {
    @apply -rotate-45;
    right: -11px;
    border-bottom-color: transparent;
    border-right-color: transparent;
  }

  &:after {
    @apply -rotate-45;
    left: -11px;
    border-top-color: transparent;
    border-left-color: transparent;
  }
}
</style>
